import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs, Tab } from "@mui/material";
const ChannelTabs = ({ tabs, value, onChange, className, tabClassName = "all-Font-Sizes", tabstyle = "full" }) => {
    const activeIndex = Math.max(0, tabs.findIndex((t) => t.key === value));
    return (_jsx(Tabs, { value: activeIndex, onChange: (_, newIndex) => onChange(tabs[newIndex]?.key), variant: "fullWidth", className: className, sx: {
            borderBottom: tabstyle == "short" ? "none" : "1px solid #EAECF0",
            "& .MuiTabs-indicator": {
                backgroundColor: "#FF008E",
                height: "2px",
            },
            width: tabstyle == "short" ? "500px" : "100%"
        }, children: tabs.map((tab, index) => (_jsx(Tab, { disabled: tab.disabled, label: tab.label, className: tabClassName, sx: {
                textTransform: "none",
                fontWeight: 500,
                color: activeIndex === index ? "#FF008E !important" : "#667085",
                bgcolor: activeIndex === index ? "#FFFAFD" : "transparent",
                border: tabstyle == "short" ? "none" : "1px solid #EAECF0"
            } }, tab.key))) }));
};
export default ChannelTabs;
